import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { noticeDetail } from '../../@apis/v1/community.service';
import AppBar from '../../components/atoms/appbar';
import { formatDate } from '../../lib/utils/dateUtils';
import { staticURL } from '../../lib/utils/imageUtils';

export default function NoticeDetail() {
    const { id } = useParams<{ id: string }>();

    const { data, isLoading, isError } = useQuery({
        queryKey: ['noticeDetail', id],
        queryFn: () => noticeDetail(id!),
        enabled: !!id,
    });

    const notice = data?.data.notice;

    if (isLoading) return <div className="p-4">불러오는 중...</div>;
    if (isError || !notice) return <div className="p-4">공지사항을 불러올 수 없습니다.</div>;

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <AppBar backButton title="공지사항" />

            {/* 상세 영역 */}
            <section className="px-[15px] mb-[15px]">
                <div className="pt-4">
                    {/* 날짜 */}
                    <p className="text-[#888] font-[500] text-sm">
                        {formatDate(notice?.updateDt || '', 'YYYY년 MM월 DD일')}
                    </p>

                    {/* 제목 */}
                    <h1 className="mt-[15px] mb-[19px] font-bold text-[#222] text-xl">{notice.title}</h1>

                    {/* 구분선 */}
                    <hr className="border-t border-[#e6e6e6]" />

                    {/* 본문 */}
                    {/* <p className="mt-[19px] leading-[1.5] font-[500] text-[#222] whitespace-pre-line">
                        {notice.content}
                    </p> */}

                    <div
                        className="break-keep [&_img]:max-w-full mt-[19px] leading-[1.5] font-[500] text-[#222] whitespace-pre-line"
                        dangerouslySetInnerHTML={{
                            __html: notice.content,
                        }}
                    />

                    {/* 이미지들 */}
                    {!!notice.fileList?.length && (
                        <div className="mt-[24px] space-y-4">
                            {notice.fileList.map((file, idx) => (
                                <div key={file.id} className="w-full rounded-[15px] overflow-hidden">
                                    <img
                                        src={staticURL(file.fileUrl)}
                                        alt={`공지 이미지 ${idx + 1}`}
                                        className="w-full"
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
